import { config } from '../../config';

export async function getHybridFlowRefreshToken(): Promise<string | null | undefined> {
  return localStorage.getItem(config.hybridFlowRefreshTokenStorageKey);
}
